import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=2cd2a2e4&scoped=true"
var script = {}
import style0 from "./BackIcon.vue?vue&type=style&index=0&id=2cd2a2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2a2e4",
  null
  
)

export default component.exports